import React, { Component } from "react";
import "./saveGoodsImage.scss";
import { Toast, WhiteSpace, WingBlank, Button, Tag } from "antd-mobile";
import axios from "../axios";
import html2canvas from "html2canvas";

var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

class saveGoodsImage extends React.Component {

     
    constructor(props){
        super(props);
       
        this.state = {
            userId : "",
            resultObject : {},
            allGoodstag : "",
            type: "",
            goodstypeimage : "sy_sell.png",
            postage : "",
            lastTimeStrArray : [],
            grageString : "未评级",
            postageStr : "",
            userTag : "",
            portrait : "",
            futuresName : "",
            dealPattern: "担保交易",
            bondAmount : "",
            pubUserInfo:{},
            goodsOrder:{
                goodsDesc : "",
            },
            goodsInfo :{
                deliveryArea : "",
                latestDeliveryTime : "",
                shopActivity:"",
                validPeriod:"",
                viewNum :"",
            },
            gradeInfo:{
                gradeType : "",
                gradeName : "",
                gradeNumber : "",
                gradeScore : "",
            },
        };
    };

     getUrlParam = (name) => {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = this.props.location.search.substr(1).match(reg);
        if (r != null) {
          return decodeURI(r[2]);
        }
        return ""; //如果此处只写return;则返回的是undefined
    };

    saveWindowImage = ()=>{//保存图片
        this.setState({
            saveimgPrompt : "正在生成图片",
        })
        const captureElement = document.getElementById('content_id');
        const options = {
            scale: window.devicePixelRatio, // 高清缩放
            width: window.innerWidth,
            height: window.height,
            useCORS: true, // 解决跨域资源问题
        };
        
        html2canvas(captureElement, options).then(canvas => {
            let imgData = canvas.toDataURL('image/png' , 0.3);
            var ua = navigator.userAgent.toLowerCase();
            var isApp = ua.match(/youbaoapploadinghtml/i) == "youbaoapploadinghtml";
            let imageData = imgData.substring(imgData.indexOf(',') + 1);
            if (isApp) {
                if (isiOS) {
                    try {
                        window.webkit.messageHandlers.IOSNativeSaveImage.postMessage({"imageData" : imageData});
                    } catch (e) {
                    }
                }else{
                    try {
                        window.app.androidNativeSaveImage(imageData);
                    } catch (e) {
                    }
                }
            }
        });
    }

    componentDidMount (){

        sessionStorage.setItem("Authorization",this.getUrlParam('tokenHead')+' '+this.getUrlParam('tokenCode'));
        sessionStorage.setItem("cAppVersion",this.getUrlParam('v'));
        let userId = this.getUrlParam('userId');
        const newDate = formatDate();
        let oid = this.getUrlParam('oid');
        const _this = this;
        axios
            .post("data/json/getScreenshotDetails",{userId : userId, oid : oid, pageType : 'goods'})
            .then(function (response){
                
                if (response.data.code === 10000) {
                    let resultObject = response.data.resultObject;
                    let goodsInfo = resultObject.goodsInfo;
                    let goodsOrder = resultObject.goodsOrder;
                    let pubUserInfo = goodsOrder.pubUserInfo;

                    let allGoodstag = "";
                    if (!(goodsOrder.bondAmount === '0') && goodsOrder.goodsTag === 'PJ' ) {
                        allGoodstag =  "YB_bondAndPing_goods_icon.png";
                    }else if (!(goodsOrder.bondAmount === '0')) {
                        allGoodstag = "YB_bond_golden_goods_icon.png";
                    } else if (goodsOrder.goodsTag === 'PJ') {
                        allGoodstag = "YB_ping_goods_icon.png";
                    }else if (goodsOrder.goodsTag === 'PH') {
                        allGoodstag = "YB_pei_goods_icon.png";
                    }

                    var lastTimeStrArray = [];
                    if (goodsInfo.latestDeliveryTime.indexOf("#")) {
                       lastTimeStrArray = goodsInfo.latestDeliveryTime.split('#');
                    } 
                    var grageString = "未评级";
                    let futuresName = "现货";
                    let goodstypeimage = "sy_sell.png";
                    switch (parseInt(goodsOrder.goodsType)) {
                        case 1:
                        case 3:
                            if (goodsOrder.goodsState === '2') {
                                futuresName = "预买";
                            }
                            if (goodsOrder.goodsTag === 'PJ') {
                                grageString = "商品必须已评级";
                            }
                            if (parseInt(goodsOrder.goodsType) === 3) {
                                goodstypeimage = "sy_flashbuy.png"
                            } else {
                                goodstypeimage = "sy_buy.png"
                            }
                            break;
                        case 2:
                        case 4:
                            if (goodsOrder.goodsState === '2') {
                                futuresName = "预售";
                            }
                            if (goodsOrder.goodsTag === 'PJ') {
                                grageString = "已评级";
                            }
                            if (parseInt(goodsOrder.goodsType) === 4) {
                                goodstypeimage = "sy_flashsell.png";
                            } else {
                                goodstypeimage = "sy_sell.png";
                            }
                            break;
                        default:
                            break;
                    }
                    let dealPattern = "担保交易";
                    switch (goodsOrder.tradeType) {
                        case '2':
                            dealPattern = "担保交易";
                            break;
                        case '3':
                            dealPattern = "线下交易";
                            break;
                        case '5':
                            dealPattern = "担保交易 线下交易";
                            break;
                        default:
                            break;
                    }
            
                    let portrait = pubUserInfo.portrait;
                    var userTag = "";
                    if (pubUserInfo.authType.length) {
                        userTag = pubUserInfo.authType;
                    }

                    let bonds = '0';
                    if (resultObject.dealCnt && resultObject.dealMin) {
                        bonds = parseInt(parseInt(resultObject.dealCnt)/parseInt(resultObject.dealMin));
                    }

                    let postage = "";
                    if (goodsOrder.postage) {
                        if (goodsOrder.postage === '0') {
                            postage = "包邮";
                        }else{
                            postage = goodsOrder.postage;
                        }  
                    }

                    _this.setState({
                        userId : userId,
                        newDate : newDate,
                        resultObject : resultObject,
                        goodsInfo : goodsInfo,
                        goodsOrder : goodsOrder,
                        pubUserInfo : pubUserInfo,
                        type :goodsOrder.goodsType,
                        goodstypeimage :goodstypeimage,
                        allGoodstag :allGoodstag,
                        lastTimeStrArray : lastTimeStrArray,
                        grageString : grageString,
                        gradeInfo :goodsOrder.gradeInfo,
                        userTag :userTag,
                        portrait : portrait,
                        postage : postage,
                        futuresName : futuresName,
                        dealPattern :dealPattern,  
                    })

                    setTimeout(() => {
                        _this.saveWindowImage();
                    }, 500);
                }else {
                    let message = response.data.message;
                    Toast.show(message, 2);
                }
            })

            .catch(function (error) {
                console.log(error);
            });      
    }

    render() {
        return (
            <div className="saveGoodsImage_div">

                <div id="content_id" className="content_div">

                    <div className="navTitle_div">
                        <p>邮宝APP</p>
                    </div>
                    <div className="title_price_div">
                        <div className="left_column_div">
                            <p>￥<span className="priceNumber_span">{this.state.resultObject.price}</span><span className="unit_span">/{this.state.resultObject.unit}</span></p>
                            <div className="goodsName_div">
                                <img className="buysell_img" src={require("../assets/" + this.state.goodstypeimage)}></img>
                                {this.state.allGoodstag.length >0 ?(<img className="buysell_img" src={require('../assets/'+ this.state.allGoodstag)}></img>):null} 
                                <p className="title_p">{this.state.resultObject.title}</p>
                            </div>   
                        </div>
                        <div className="right_button_div">
                            <button className="collection_button">{this.state.type === '1' || this.state.type === '3' ? "我有出售意向"  : "我有购买意向"}</button>
                            <button className="market_button">最新市场行情</button>
                        </div>
                    </div>
                    <p className="nickName_p">{this.state.resultObject.nickname} {this.state.newDate}</p>

                    <div className="goods_list_div">
                        <div className="class_list_div">
                            <div className="lift_nameType_div">
                                <p className="nametype_p">交易类别：{this.state.type === '1' || this.state.type === '3' ? "买盘"  : "卖盘"}</p>
                                <p className="nametype_p">剩余数量: {this.state.goodsOrder.reminderNum}{this.state.resultObject.unit}</p>
                                <p className="nametype_p">最小确认量: {this.state.goodsOrder.dealMinNum}{this.state.resultObject.unit}</p>
                                <p className="nametype_p">保证金总份数: <span className="red_span">{this.state.goodsOrder.totalBondNum}</span></p>
                                <p className="nametype_p">单份保证金: <span className="red_span">￥{this.state.goodsOrder.bondAmount}</span></p>
                                {this.state.type === '2' || this.state.type === '4' ? (<p className="nametype_p">邮费: <span className="red_span">{this.state.postage}</span></p>) : (<p className="nametype_p">交易方式: {this.state.dealPattern}</p>)}
                            </div>
                            <div className="center_line_div"></div>
                            <div className="right_nameType_div">
                                <p className="nametype_p">分类：{this.state.goodsOrder.categoryName}</p>
                                <p className="nametype_p">品相: <span className="green_span">{this.state.goodsOrder.conditionName}</span></p>
                                <p className="nametype_p">浏览量: {this.state.goodsInfo.viewNum}</p>
                                <p className="nametype_p">评级鉴定: {this.state.grageString}</p>
                                <p className="nametype_p">货物状态: {this.state.futuresName}</p>
                                {this.state.type === '2' || this.state.type === '4' ? (<p className="nametype_p">交易方式: {this.state.dealPattern}</p>) : null}
                            </div>
                        </div>
                        
                    </div>
                    <div className="seat_div"></div>

                    <div className="list_two_div">
                    
                        <p className="twonametype_p">有效期限<span className="twotypeContent_span">{this.state.goodsInfo.validPeriod}</span></p>
                        {this.state.lastTimeStrArray.length ? 
                          (<p className="twonametype_p">最晚发货时间<span className="twotypeContent_span">{this.state.lastTimeStrArray[0]}<span className="lastTimeRed_span">{this.state.lastTimeStrArray[1]}</span>{this.state.lastTimeStrArray[2]}</span></p>)
                          : 
                          (<p className="twonametype_p">最晚发货时间<span className="twotypeContent_span">{this.state.goodsInfo.latestDeliveryTime}</span></p>)
                        }
                        {(this.state.goodsInfo.deliveryArea.length > 0) ? (<p className="twonametype_p">发货地区<span className="twotypeContent_span">{this.state.goodsInfo.deliveryArea}</span></p>): null}
                        {!(this.state.grageString === '未评级') ?(<p className="twonametype_p">评级鉴定:<span className="twotypeContent_span">{this.state.grageString}</span></p>) : null}

                        {!(this.state.grageString === '未评级') ? (
                            <div className="grade_data_div"> 
                                {(this.state.gradeInfo.gradeName.length > 0) ? (<p className="twonametype_p grade_data_p">评级机构名称:<span className="twotypeContent_span">{this.state.gradeInfo.gradeName}</span></p>) : null} 
                                {(this.state.gradeInfo.gradeNumber.length > 0) ? (<p className="twonametype_p grade_data_p">评级证书编号:<span className="twotypeContent_span">{this.state.gradeInfo.gradeNumber}</span></p>) : null}
                                {(this.state.gradeInfo.gradeScore.length > 0) ? (<p className="twonametype_p grade_data_p">评级鉴定评分:<span className="twotypeContent_span">{this.state.gradeInfo.gradeScore}</span></p>) : null}
                            </div>
                            ): null
                        }
                        {this.state.goodsInfo.shopActivity.length > 0 ? (<p className="twonametype_p">店铺活动:<span className="twotypeContent_span">{this.state.goodsInfo.shopActivity}</span></p>): null}
                        {this.state.goodsOrder.goodsDesc.length > 0 ? (<p className="twonametype_p">商品描述:<span className="twotypeContent_span">{this.state.goodsOrder.goodsDesc}</span></p>): null}
                    </div>

                    <div className="seat_div"></div>

                    <div className="userdata_div">
                        <img className="userHeader_img" src={this.state.portrait.length >0 ? (this.state.portrait) : require("../assets/grzx_touxiang@2x.png")}></img>
                        <div className="userName_div">
                            <p className="username_p">{this.state.pubUserInfo.nickname}<span className="levle_span">Lv.{this.state.pubUserInfo.level}</span></p>
                            <img className="uesrtag_img" src={ this.state.userTag == "商家" ? require("../assets/smrz_shangjiabiaoqianIcon@2x.png") : this.state.userTag == "个人"? require("../assets/smrz_gerenbiaoqianIcon@2x.png") :require("../assets/smrz_weirenzhenicon@2x.png")}></img>
                        </div> 
                    </div>
                </div>
           </div>
        );   
    }
}

function formatDate() {
  const date = new Date();
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  const seconds = ('0' + date.getSeconds()).slice(-2);
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}



export default saveGoodsImage;
